"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFilterPartsToParams = exports.getFilterKeySubs = exports.getKeyValueSub = exports.getKeyNameSub = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const lambda_1 = require("../lambda");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const dyn = config_1.default.aws.dynamoDB;
const getKeyNameSub = (key) => `#${key}`;
exports.getKeyNameSub = getKeyNameSub;
const getKeyValueSub = (key) => `:${key}`;
exports.getKeyValueSub = getKeyValueSub;
const matchArrayPart = /\[\d+\]+/;
const replaceArrayPart = /\[\d+\]/g;
const replaceDotPart = /\./g;
const nothing = '';
const underscore = '_';
const dot = '.';
/**
 * @function getFilterKeySubs
 * @param filterGroupIdx Not currently used
 * @param key
 * @returns {
 *  dotAccessParts: Array of attribute keys that are to be put in ExpressionAttributeNames,
 *  keyNameSubs: Array of key names that form the key to dotAccessParts
 *  predicateKeyName: the dotted name to be used as input to filter parts
 *  keyValueSub: the :values to be used in ExpressionAttributeValues
 * }
 */
const getFilterKeySubs = (key, processedTimes) => {
    const keyNamePrefix = nothing; //`fg${filterGroupIdx}_`;
    const dotAccessParts = key.split(dot);
    const keyNameSubsAndArray = dotAccessParts.map((keyPart) => {
        const arrayPartRes = keyPart.match(matchArrayPart);
        const arrayPart = arrayPartRes && arrayPartRes[0];
        const noArrayKeyyPart = keyPart.replace(replaceArrayPart, nothing);
        return { keyNameSub: (0, exports.getKeyNameSub)(`${keyNamePrefix}${noArrayKeyyPart}`), arrayPart };
    });
    // in dealing with multiple same key do we need to put anything other that key onto processedKeys
    const numberedKey = `${key}_${processedTimes}`;
    const keyValueSub = (0, exports.getKeyValueSub)(`${numberedKey}`).replace(replaceDotPart, underscore).replace(replaceArrayPart, nothing);
    const noArrayDotAccessParts = dotAccessParts.map((dotAccessPart) => dotAccessPart.replace(matchArrayPart, nothing));
    return {
        dotAccessParts: noArrayDotAccessParts,
        keyNameSubs: keyNameSubsAndArray.map(({ keyNameSub }) => keyNameSub),
        predicateKeyName: keyNameSubsAndArray.map(({ keyNameSub, arrayPart }) => `${keyNameSub}${arrayPart ?? nothing}`).join(dot),
        keyValueSub,
    };
};
exports.getFilterKeySubs = getFilterKeySubs;
const getFilterAddition = (keyNameSub, filter, keyValueSub) => {
    let addition = '';
    if ((0, iotv_v3_types_1.isNullValueFilterPartType)(filter)) {
        addition = `${filter.predicate}( ${keyNameSub} )`;
    }
    else {
        if ((0, iotv_v3_types_1.isComparisonType)(filter.predicate)) {
            addition = `${keyNameSub} ${filter.predicate} ${keyValueSub}`;
        }
        else if ((0, iotv_v3_types_1.isExpressionFunctionType)(filter.predicate)) {
            addition = `${filter.predicate}( ${keyNameSub}, ${keyValueSub} )`;
        }
    }
    return addition;
};
const addFilterPartsToParams = ({ params, groupSetOperation, filterGroups, adjacencyType, keyLookUp }) => {
    const processedKeys = {};
    filterGroups.forEach((filterGroup, fgIdx) => {
        let filterGroupKeyExpression = '';
        let filterGroupFilterExpression = '';
        filterGroup.filters.forEach((filter) => {
            /**
             * UNDER REVIEW - ( yikes ! )
             * this didn't work with filters that contain the same attribute key as ( or at least for OR'd parts ) because the attribute value eg :edgeTypeId is repeated
             * the function would need to look back at previous added keys and if same had been added before, create a different # and : entry
             */
            const processedTimes = processedKeys[filter.key] ?? 0;
            const { dotAccessParts, keyNameSubs, predicateKeyName, keyValueSub } = (0, exports.getFilterKeySubs)(filter.key, processedTimes);
            const filterAddition = getFilterAddition(predicateKeyName, filter, keyValueSub);
            keyNameSubs.forEach((keyNameSub, i) => (params.ExpressionAttributeNames[`${keyNameSub}`] = dotAccessParts[i]));
            if (!(0, iotv_v3_types_1.isNullValueFilterPartType)(filter)) {
                params.ExpressionAttributeValues[`${keyValueSub}`] = filter.value;
            }
            /** 2024 02 generalization of moving index filters to keyExpression */
            const isKeyFilterPart = (filter) => {
                const { key } = filter;
                const indexDef = keyLookUp[adjacencyType];
                const { sortKey, hashKey } = indexDef;
                const isKeyExpression = [sortKey, hashKey].includes(key);
                debug && console.log('isKeyFilterPart', { filter, indexDef, isKeyExpression });
                return isKeyExpression;
            };
            // if below was adjacencyType !== AdjacentType.SUBJECT && [dyn.sKey, dyn.pKey ].includes(filter.key)
            /** if the filter is on an index, place in key expression, else place in filter
             * This should be improved to not accept unsupported index key expression functions like contains
             */
            if (isKeyFilterPart(filter)) {
                filterGroupKeyExpression = filterGroupKeyExpression ? `${filterGroupKeyExpression} ${filterGroup.setOperation} ${filterAddition}` : `${filterAddition}`;
            }
            else {
                filterGroupFilterExpression = filterGroupFilterExpression
                    ? `${filterGroupFilterExpression} ${filterGroup.setOperation} ${filterAddition}`
                    : `${filterAddition} `;
            }
            if (!processedKeys[filter.key]) {
                processedKeys[filter.key] = 1;
            }
            else {
                processedKeys[filter.key] = processedKeys[filter.key] + 1;
            }
        });
        /* end of filterGroups, start of add to paramters */
        if (filterGroupKeyExpression) {
            params.KeyConditionExpression = `${params.KeyConditionExpression} ${groupSetOperation} ${filterGroupKeyExpression}`;
        }
        if (filterGroupFilterExpression) {
            /* 2024 06 added initial parathesis even if single expression to support multiple filter groups */
            params.FilterExpression = params.FilterExpression
                ? `${params.FilterExpression} ${groupSetOperation} ( ${filterGroupFilterExpression} )`
                : `( ${filterGroupFilterExpression} )`;
        }
    });
};
exports.addFilterPartsToParams = addFilterPartsToParams;
